import { stringify } from "../../util/querystring-util";
import { restResourceRequester } from "../rest-resource-requester";
import { GetComponentProjectListRequest } from "./get-component-project-list/GetComponentProjectListRequest";
import { GetComponentProjectListResponse } from "./get-component-project-list/GetComponentProjectListResponse";
import { UpdateComponentProjectsRequest } from "./update-component-projects/UpdateComponentProjectsRequest";
import { UpdateComponentProjectsResponse } from "./update-component-projects/UpdateComponentProjectsResponse";
import { GetComponentProjectsDeployCandidateRequest } from "./get-component-projects-deploy-candidate/GetComponentProjectsDeployCandidateRequest";
import { GetComponentProjectsDeployCandidateResponse } from "./get-component-projects-deploy-candidate/GetComponentProjectsDeployCandidateResponse";

interface ComponentProjectsRestResource {
  getComponentProjectList(
    request: GetComponentProjectListRequest,
  ): Promise<GetComponentProjectListResponse>;
  updateComponentProjects(
    request: UpdateComponentProjectsRequest,
  ): Promise<UpdateComponentProjectsResponse>;
  getComponentProjectsDeployCandidate(
    request: GetComponentProjectsDeployCandidateRequest,
  ): Promise<GetComponentProjectsDeployCandidateResponse>;
}

const REST_RESOURCE_NAME = {
  COMPONENT_PROJECTS: "/component-projects",
};

/**
 * POST /get-component-project-list
 */
const getComponentProjectList = restResourceRequester<
  GetComponentProjectListRequest,
  GetComponentProjectListResponse
>(
  "POST",
  (_) => `${REST_RESOURCE_NAME.COMPONENT_PROJECTS}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /component-project
 */
const updateComponentProjects = restResourceRequester<
  UpdateComponentProjectsRequest,
  UpdateComponentProjectsResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.COMPONENT_PROJECTS}`,
  (request) => JSON.stringify(request),
);

/**
 * GET /component-project/deploy-candidate
 */
const getComponentProjectsDeployCandidate = restResourceRequester<
  GetComponentProjectsDeployCandidateRequest,
  GetComponentProjectsDeployCandidateResponse
>(
  "GET",
  (request) =>
    `${REST_RESOURCE_NAME.COMPONENT_PROJECTS}/deploy-candidate?${stringify(
      request,
    )}`,
);

export const componentProjectsRestResource: ComponentProjectsRestResource = {
  getComponentProjectList: getComponentProjectList,
  updateComponentProjects: updateComponentProjects,
  getComponentProjectsDeployCandidate: getComponentProjectsDeployCandidate,
};
